<template>
  <van-nav-bar
    :title="$t('routerBase.'+$route.meta.i18n)"
    left-arrow
    fixed
    @click-left="onClickLeft"
    @click-right="onClickRight"
  />
</template>

<script>

export default {
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler(val) {
        this.$route.meta.i18n = this.$route.query.names || this.$route.meta.i18n
        this.$route.meta.title = this.$route.query.names || this.$t(this.$route.meta.i18n)
      }
    }
  },
  created() {

  },
  methods: {
    onClickLeft() {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    //   Toast('返回')
    },
    onClickRight() {
    //   $this.Toast('按钮')
    }
  }
}
</script>

<style lang="scss" scoped>
  .van-nav-bar{
    z-index:100!important;
  }
  .van-nav-bar .van-icon {
    color: #333;
    font-size: 20px;
  }
</style>

